// src/stone/icons/Stone.tsx
import { jsx } from "react/jsx-runtime";
var Stone = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M12.094.098c.213-.076.44-.109.666-.095C19.034.397 24 5.62 24 12s-4.965 11.6-11.24 11.997h-.002A1.655 1.655 0 0 1 11 22.343v-4.139a1.756 1.756 0 0 1 1.555-1.73 4.5 4.5 0 0 0 2.812-1.488 4.516 4.516 0 0 0 0-5.975 4.5 4.5 0 0 0-2.812-1.488A1.753 1.753 0 0 1 11 5.793V1.657a1.66 1.66 0 0 1 1.094-1.56M13 2.028c5.05.503 9 4.775 9 9.972s-3.948 9.467-9 9.971v-3.54a6.5 6.5 0 0 0 3.867-2.122 6.516 6.516 0 0 0 0-8.62A6.5 6.5 0 0 0 13 5.565zM4.547 5.584c1.248-1.296 3.44-.412 3.44 1.387v9.058c0 1.8-2.192 2.683-3.44 1.387L.853 13.581a3 3 0 0 1 0-4.162zm1.44 1.387-3.694 3.835a1 1 0 0 0 0 1.388l3.694 3.835z" })
  }
);
var Stone_default = Stone;

export {
  Stone_default
};
